import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {entityUpdateFeatureKey, reducer} from './entity-update.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityUpdateFeatureKey, reducer),
  ],
})
export class EntityUpdateModule {
}
